import { atom } from "recoil";

export const myTimesheetFilterCounterState = atom({
  key: "myTimesheetFilterCounterState",
  default: {
    contract: 0,
    project: 0,
    client: 0,
    cost: 0,
  },
});

export default myTimesheetFilterCounterState;
